import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"

import { Text, Image } from "../Core"
import { SocialIconLink } from "../SocialReviews"
import { Columns } from "../../components/Containers"
import GeneralHours from "../Core/GeneralHours"
import { Office, Phone, Email } from "../locations"

const Footer = ({ isHomePage, language }) => {
  const { site, footerData, privacy, trans, socialAccounts, allLocations } =
    useStaticQuery(
      graphql`
        query {
          site {
            siteMetadata {
              fullPracticeName
            }
          }
          footerData: allDataJson(filter: { optionsItem: { eq: "footer" } }) {
            nodes {
              footerItems {
                blurbText
                blurbTextEs
              }
            }
          }
          privacy: allPrivacyPagesJson(sort: { order: ASC, fields: order }) {
            nodes {
              title
              name
            }
          }
          socialAccounts: allDataJson(
            filter: { optionsItem: { eq: "siteVariables" } }
          ) {
            nodes {
              hasWuwta
              hasStemodonctics
              socialAccounts {
                link
                platform
              }
            }
          }
          allLocations: allLocationsJson(
            filter: { useOnFooter: { eq: true } }
            sort: { fields: locationData___order }
          ) {
            nodes {
              title
              pageData {
                title
                hasThisPage
              }
              locationData {
                socialAccounts {
                  platform
                  link
                }
                cityName
                cityZip
                email
                googlePlaceLink
                locationHours {
                  endTime
                  startTime
                  weekDay
                }
                locationName
                phone
                fax
                stateAbbr
                stateName
                streetName
                streetNumber
              }
            }
          }
          trans: allTranslationsJson {
            nodes {
              credit {
                en
                es
              }
              by {
                en
                es
              }
              phone {
                en
                es
              }
              email {
                en
                es
              }
              hours {
                en
                es
              }
              address {
                en
                es
              }
              giveUsACall {
                en
                es
              }
              getDirections {
                en
                es
              }
              office {
                en
                es
              }
              learnMoreAboutOur {
                en
                es
              }
              followUs {
                en
                es
              }
            }
          }
        }
      `
    )
  const translations = trans.nodes[0]
  const social = socialAccounts.nodes[0].socialAccounts
  const locations = allLocations.nodes
  const footerblurb = footerData.nodes[0].footerItems.blurbText
  const blurbTextEs = footerData.nodes[0].footerItems.blurbTextEs

  const hasOneLocation = locations.length === 1
  const useSiteVariableSocials = true // false === individual location page json socials

  const madeByNuvo = true
  const hasWuwta = socialAccounts.nodes[0].hasWuwta
  const hasStemodonctics = socialAccounts.nodes[0].hasStemodonctics

  return (
    <footer className="footer">
      <div className="footer__main">
        <Columns sideColumnsSize={2}>
          <div className="column footer__primary">
            <div className="footer__logo-with-tagline">
              <div className="footer__logo">
                <Image publicId={"7x7/V2/7x7-logo-mark-white"} useAR={false} />
              </div>
              <Text
                as="h6"
                text={language === "es" ? blurbTextEs : footerblurb}
              />
            </div>
            <div className="footer__social-media">
              <Text as="p" text={translations.followUs[language]} />
              <div className="footer__social-icons-container">
                {social.map(soc => (
                  <SocialIconLink
                    key={soc.link}
                    platform={soc.platform}
                    link={soc.link}
                  />
                ))}
              </div>
            </div>
          </div>
        </Columns>

        {/* HAS ONE LOCATION */}
        {hasOneLocation ? (
          <>
            <Columns sideColumnsSize={2}>
              <Columns
                sideColumnsSize={0}
                className="footer__contact footer__single-location">
                <div className="footer__tagline">
                  <div className="footer__logo">
                    <Image publicId="7X7/V2/logo-mark" />
                  </div>
                  <Text
                    className="mt-0"
                    as="h6"
                    text={language === "es" ? blurbTextEs : footerblurb}
                  />
                </div>
                <div>
                  <div className="footer__pages-list">
                    <Link to={`/about/`} title={"About Us"}>
                      About Us
                    </Link>
                    <Link
                      to={`/oral-surgery-procedures/`}
                      title={"All Procedures"}>
                      All Procedures
                    </Link>
                    <Link to={`/registration/`} title={"Patient Registration"}>
                      Patient Registration
                    </Link>
                    <Link to={`/contact/`} title={"Contact us"}>
                      Contact
                    </Link>
                  </div>

                  {!useSiteVariableSocials && (
                    <div className="footer__social mt-2">
                      {locations[0].locationData.socialAccounts.map(soc => (
                        <SocialIconLink
                          key={soc.link}
                          platform={soc.platform}
                          link={soc.link}
                        />
                      ))}
                    </div>
                  )}
                </div>
                <div className="footer__contact-list">
                  <div>
                    {locations[0].pageData.hasThisPage && (
                      <Link
                        title={`Learn more about our ${locations[0].locationData.locationName} location`}
                        to={`/${locations[0].pageData.title}`}>
                        <h6 className="mb-0">
                          {translations.address[language]}
                        </h6>
                      </Link>
                    )}
                    <Office
                      city={locations[0].locationData.cityName}
                      state={locations[0].locationData.stateAbbr}
                      zip={locations[0].locationData.cityZip}
                      streetName={locations[0].locationData.streetName}
                      streetNumber={locations[0].locationData.streetNumber}
                      gmb={locations[0].locationData.googlePlaceLink}
                    />
                  </div>
                  <GeneralHours
                    language={language}
                    locationHours={locations[0].locationData.locationHours}
                  />
                  <Phone
                    className="block mb-0"
                    phoneNumber={locations[0].locationData.phone}
                  />
                  {/* <Email
                    className="block mb-0"
                    email={locations[0].locationData.email}
                  /> */}
                </div>
                <div>
                  {useSiteVariableSocials && (
                    <div className="footer__social-media">
                      <Text as="p" text="Follow Us!" />
                      <div className="footer__social-icons-container">
                        {social.map(soc => (
                          <SocialIconLink
                            key={soc.link}
                            platform={soc.platform}
                            link={soc.link}
                          />
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </Columns>
            </Columns>
          </>
        ) : (
          <Columns sideColumnsSize={2} className="footer__locations">
            {locations.map((local, i) => (
              <React.Fragment key={i}>
                <div className={`column footer__single-location`}>
                  <div>
                    {local.pageData.hasThisPage ? (
                      <Link
                        className="block mb-0 mx-auto--mobile"
                        style={{ width: "fit-content" }}
                        to={`/${local.pageData.title}`}
                        title={`${translations.learnMoreAboutOur[language]} ${local.locationData.locationName} ${translations.office[language]}`}>
                        <h6>
                          {local.locationData.locationName}{" "}
                          {translations.office[language]}
                        </h6>
                      </Link>
                    ) : (
                      <h6 className=" mb-0 mx-auto--mobile">
                        {local.locationData.locationName} Office
                      </h6>
                    )}
                    <Office
                      linkTitle={translations.getDirections[language]}
                      city={local.locationData.cityName}
                      state={local.locationData.stateAbbr}
                      zip={local.locationData.cityZip}
                      streetName={local.locationData.streetName}
                      streetNumber={local.locationData.streetNumber}
                      gmb={local.locationData.googlePlaceLink}
                      className="mb-2"
                    />
                    <br />
                    {local.locationData.phone && (
                      <>
                        {/* <h6 className="mt-1">{translations.phone[language]}</h6> */}
                        <Phone
                          language={language}
                          phoneNumber={local.locationData.phone}
                        />
                      </>
                    )}
                    <br />
                    {/* <Email
                      language={language}
                      email={local.locationData.email}
                    /> */}
                  </div>
                  <div>
                    <h6>{translations.hours[language]}</h6>
                    <GeneralHours
                      language={language}
                      locationHours={local.locationData.locationHours}
                    />
                  </div>
                  {!useSiteVariableSocials && (
                    <div className="footer__social mt-1">
                      {local.locationData.socialAccounts.map(soc => (
                        <SocialIconLink
                          key={soc.link}
                          platform={soc.platform}
                          link={soc.link}
                        />
                      ))}
                    </div>
                  )}
                </div>

                {i < locations.length - 1 && <div className="column is-1" />}
              </React.Fragment>
            ))}
            <div className="footer__mobile-social-media">
              <div className="footer__social-icons-container">
                {social.map(soc => (
                  <SocialIconLink
                    key={soc.link}
                    platform={soc.platform}
                    link={soc.link}
                    size={"40px"}
                  />
                ))}
              </div>
            </div>
            {/* <div className="column is-narrow mt-3--mobile">
              <h6>Contact</h6>
              <Email
                language={language}
                email={locations[0].locationData.email}
              />
            </div> */}
          </Columns>
        )}
      </div>

      <Columns sideColumnsSize={2} className="footer__secondary">
        <div className="column">
          <div className="footer__secondary-links">
            <div className="footer__privacy">
              <p>
                © {new Date().getFullYear()}{" "}
                {site.siteMetadata.fullPracticeName}.{" "}
                <span className="no-wrap">All rights reserved.</span>
              </p>
              {privacy.nodes.map(priv => (
                <p key={priv.title} className="footer__privacy-link">
                  <Link to={`/${priv.title}`} title={priv.name}>
                    {priv.name}
                  </Link>
                </p>
              ))}
            </div>
          </div>
        </div>
      </Columns>

      {isHomePage && language === "en" && (
        <div className="bg-dark">
          <Columns sideColumnsSize={2} className="footer__companies">
            {madeByNuvo && (
              <div className="column">
                <p className="footer__brand mt-0">
                  <a
                    className="bold"
                    href="https://nuvolum.com"
                    target="_blank"
                    title={`${translations.credit[language]} ${translations.by[language]} Nuvolum`}>
                    {translations.credit[language]}
                  </a>{" "}
                  <span className="no-wrap">
                    {translations.by[language]} Nuvolum™
                  </span>
                </p>
              </div>
            )}
            {hasStemodonctics && (
              <p className="footer__brand mt-0">
                <a
                  href="https://stemodontics.com/"
                  title="Easily bank stem cells from wisdom teeth with Stemodontics"
                  target="_blank">
                  Stem Cell Banking by Stemodontics<sup>®</sup>
                </a>
              </p>
            )}
            {hasWuwta && (
              <p className="footer__brand mt-0">
                <a
                  href="https://getwuwta.com/"
                  title="WUWTA - The Patient Communication Platform That Delivers Superior Outcomes"
                  target="_blank">
                  Patient experience powered by WUWTA™
                </a>
              </p>
            )}
          </Columns>
        </div>
      )}
    </footer>
  )
}

export default Footer
